import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { resourcesPage } from '../data/resources';
export function ResourcesPage() {
  const {
    hero,
    collections
  } = resourcesPage;
  return <>
      {/* Hero with modest supporting image */}
      <section id="top" aria-labelledby="resources-title" className="bg-ivory pb-12 pt-10 md:pb-16 md:pt-14 lg:pb-20 lg:pt-16" data-id="element-701" data-mp="3h1fqf2b5gyk5">
        <div className="site-container grid gap-10 lg:grid-cols-12 lg:items-center lg:gap-14" data-id="element-702" data-mp="3752ya8v96sri">
          <div className="lg:col-span-7" data-id="element-703" data-mp="333r7w14k23i9">
            <p className="eyebrow text-moss" data-id="element-704" data-mp="332y6lfod867i">{hero.eyebrow}</p>
            <h1 id="resources-title" className="mt-5 font-display text-[42px] font-medium leading-[1.03] tracking-[-0.01em] text-charcoal sm:text-[56px] lg:text-[68px]" data-id="element-705" data-mp="2y4egr46nia9v">
              {hero.title}
            </h1>
            <p className="mt-6 max-w-[560px] text-[16px] leading-relaxed text-charcoal/75 sm:text-[18px]" data-id="element-706" data-mp="wci8c3fs5gjb">{hero.intro}</p>
          </div>
          <div className="lg:col-span-5" data-id="element-707" data-mp="2u37jc9djjavg">
            <div className="relative aspect-[16/10] overflow-hidden bg-stone lg:aspect-[4/3]" data-id="element-708" data-mp="2u269274cmses">
              <img src={hero.image} alt={hero.alt} className="absolute inset-0 h-full w-full object-cover" data-id="element-709" data-mp="2y5cbt4s961gi" />
            </div>
          </div>
        </div>
      </section>

      {/* Two collections */}
      <section aria-label="Article collections" className="border-t border-charcoal/10 bg-stone/60 py-14 md:py-20 lg:py-24" data-id="element-710" data-mp="2p4nvu4jatr0z">
        <div className="site-container" data-id="element-711" data-mp="3cvjw7q1tluju">
          <ul className="grid gap-6 md:grid-cols-2 md:gap-8" data-id="element-712" data-mp="3ht1vspty6xf6">
            {collections.map(c => <li key={c.id} className="flex" data-id="element-713" data-mp="3345r92r3o2jb">
                <article aria-labelledby={`${c.id}-title`} className="flex w-full flex-col border-t-2 border-olive bg-ivory p-7 sm:p-9 lg:p-11" data-id="element-714" data-mp="333dvnrxi64t1">
                  <h2 id={`${c.id}-title`} className="font-display text-[30px] font-medium leading-[1.12] text-charcoal sm:text-[36px]" data-id="element-715" data-mp="3vr08zrwj8nt3">
                    {c.title}
                  </h2>
                  <p className="mt-4 max-w-[460px] text-[16px] leading-relaxed text-charcoal/75" data-id="element-716" data-mp="9a1b4dn6xdju">{c.text}</p>
                  <a href={c.href} target="_blank" rel="noopener noreferrer" className="focus-ring group mt-auto inline-flex min-h-[48px] items-center gap-2 self-start pt-8 text-[15px] font-medium text-olive" data-id="element-717" data-mp="4aombncrdwem">
                    <span className="border-b border-olive/35 pb-0.5 transition-colors duration-150 group-hover:border-olive" data-id="element-718" data-mp="3moeb8m8n7oq3">
                      {c.action}
                    </span>
                    <ArrowUpRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" strokeWidth={1.5} aria-hidden="true" data-id="element-719" data-mp="3cs19r26uw6ks" />
                    <span className="sr-only" data-id="element-720" data-mp="1j92eikfj2q8u"> (opens in a new tab)</span>
                  </a>
                </article>
              </li>)}
          </ul>
        </div>
      </section>
    </>;
}